var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "home_work"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5705_41951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5705_41951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home_work_2",
    d: "M14.0909 7.66667H15.7273V6.11111H14.0909V7.66667ZM14.0909 10.7778H15.7273V9.22222H14.0909V10.7778ZM14.0909 13.8889H15.7273V12.3333H14.0909V13.8889ZM14.0909 17V15.4444H17.3636V4.55556H10V5.64444L8.36364 4.51667V3H19V17H14.0909ZM1 17V9.22222L6.72727 5.33333L12.4545 9.22222V17H7.54545V13.1111H5.90909V17H1ZM2.63636 15.4444H4.27273V11.5556H9.18182V15.4444H10.8182V10L6.72727 7.23889L2.63636 10V15.4444Z",
    fill: "#475467"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.ca478b725c65e67fc8bf5e906ce559f5.svg";
export { ForwardRef as ReactComponent };